import React from 'react';
import PropTypes from 'prop-types';

const Button = ({ buttonState = 'active',
    alt = false, withLeftIcon = false, withRightIcon = false,
    iconOnly = false, additionalClass = "", children, ...options }) => {

    let iconPosStyle = null;
    if (iconOnly) {
        iconPosStyle = 'button--icon-only';
    }
    else if (withLeftIcon) {
        iconPosStyle = 'button--icon-left';
    }
    else if (withRightIcon) {
        iconPosStyle = 'button--icon-right';
    }
    else {
        iconPosStyle = '';
    }


    let iconStateStyle = null;
    if (alt) {
        iconStateStyle = '';
    }
    else if (buttonState === 'disabled') {
        iconStateStyle = 'icon--disabled';
    }
    else {
        iconStateStyle = 'icon--white';
    }

    const iconSection = <span className="button--icon">
        <i className={`foundry-icon icon--chevron-down ${iconStateStyle}`}></i>
    </span>;


    return (<button className={`foundry--button button--${buttonState}${(alt === true ? '-alt' : '')} ${iconPosStyle}  ${additionalClass}`}
        type="button" {...options}>

        {(withLeftIcon && !iconOnly) && iconSection}

        {iconOnly ? iconSection : <span className="button--label">{children}</span>}

        {(withRightIcon && !iconOnly) && iconSection}

    </button>);
};

Button.propTypes = {
    // State of button (values: 'active' (default), 'disabled', 'danger') 
    buttonState: PropTypes.string,

    // Is button primary (false) or secondary (true)?
    alt: PropTypes.bool,

    // Is there a left icon on the button? (values: true, false (default))
    withLeftIcon: PropTypes.bool,

    // Is there a right icon on the button? (values: true, false (default))
    withRightIcon: PropTypes.bool,

    // Does this button only contain an icon? (values: true, false (default))
    iconOnly: PropTypes.bool,

    // Additional attributes for <button> element
    options: PropTypes.object,
    // Button text
    text: PropTypes.string,
    additionalClass: PropTypes.string
};

export default Button;